import { render, staticRenderFns } from "./InvertedHeader.vue?vue&type=template&id=86edc1f8&scoped=true&"
import script from "./InvertedHeader.vue?vue&type=script&lang=js&"
export * from "./InvertedHeader.vue?vue&type=script&lang=js&"
import style0 from "./InvertedHeader.vue?vue&type=style&index=0&id=86edc1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86edc1f8",
  null
  
)

export default component.exports